import React from 'react'
import type { IconDefaultProps } from '../../../models/types'

const SubtitlesOnIcon = ({
  className,
  color
}: IconDefaultProps): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 17 17'
      className={className || 'rf-w-4 rf-h-4'}
    >
      <g transform='translate(-41.7 -41.7)'>
        <g transform='translate(41.7 41.7)'>
          <path
            d='M52.572,58.7H47.828c-2.191,0-3.675-.463-4.67-1.458S41.7,54.763,41.7,52.572V47.828c0-2.191.463-3.675,1.458-4.67s2.479-1.458,4.67-1.458h4.745c2.19,0,3.674.463,4.669,1.458s1.459,2.479,1.459,4.67v4.745c0,2.19-.463,3.674-1.458,4.669S54.763,58.7,52.572,58.7ZM47.828,42.886c-1.856,0-3.073.353-3.831,1.111s-1.111,1.975-1.111,3.831v4.745c0,1.856.353,3.073,1.111,3.831s1.975,1.111,3.831,1.111h4.745c1.856,0,3.073-.353,3.831-1.111s1.111-1.975,1.111-3.83V47.828c0-1.856-.353-3.073-1.111-3.831s-1.975-1.111-3.83-1.111Z'
            transform='translate(-41.7 -41.7)'
            fill={color || '#FFF'}
          />
        </g>
        <g transform='translate(52.486 54.285)'>
          <path
            d='M498.663,573.49h-1.468a.595.595,0,0,1,0-1.19h1.468a.595.595,0,1,1,0,1.19Z'
            transform='translate(-496.6 -572.3)'
            fill={color || '#FFF'}
          />
        </g>
        <g transform='translate(45.252 54.285)'>
          <path
            d='M197.425,573.49h-5.13a.595.595,0,1,1,0-1.19h5.13a.595.595,0,1,1,0,1.19Z'
            transform='translate(-191.7 -572.3)'
            fill={color || '#FFF'}
          />
        </g>
        <g transform='translate(49.572 51.692)'>
          <path
            d='M378.98,464.19h-4.385a.595.595,0,1,1,0-1.19h4.385a.595.595,0,1,1,0,1.19Z'
            transform='translate(-374 -463)'
            fill={color || '#FFF'}
          />
        </g>
        <g transform='translate(45.256 51.692)'>
          <path
            d='M194.491,464.19h-2.2a.595.595,0,1,1,0-1.19h2.2a.595.595,0,1,1,0,1.19Z'
            transform='translate(-191.7 -463)'
            fill={color || '#FFF'}
          />
        </g>
        <g transform='translate(45.373 44.636)'>
          <g transform='translate(0 0)'>
            <path
              d='M201.06,170.057a1.863,1.863,0,0,1-.178.838,1.734,1.734,0,0,1-.483.6,2.072,2.072,0,0,1-.711.362,3.033,3.033,0,0,1-.871.121,2.983,2.983,0,0,1-.583-.052,3.353,3.353,0,0,1-.476-.124,2.089,2.089,0,0,1-.345-.152.958.958,0,0,1-.2-.14.35.35,0,0,1-.086-.176A1.631,1.631,0,0,1,197.1,171a2.307,2.307,0,0,1,.01-.243.725.725,0,0,1,.031-.159.169.169,0,0,1,.057-.086.137.137,0,0,1,.081-.026.411.411,0,0,1,.186.076,2.746,2.746,0,0,0,.307.171,2.851,2.851,0,0,0,.447.171,2.091,2.091,0,0,0,.6.076,1.393,1.393,0,0,0,.4-.055.88.88,0,0,0,.3-.152.675.675,0,0,0,.19-.243.8.8,0,0,0,.067-.324.578.578,0,0,0-.112-.355,1.085,1.085,0,0,0-.293-.262,3.438,3.438,0,0,0-.409-.217c-.152-.067-.312-.138-.474-.214a4.334,4.334,0,0,1-.474-.255,1.887,1.887,0,0,1-.409-.343,1.626,1.626,0,0,1-.293-.471,1.717,1.717,0,0,1-.112-.65,1.737,1.737,0,0,1,.162-.766,1.565,1.565,0,0,1,.435-.547,1.852,1.852,0,0,1,.645-.326,2.841,2.841,0,0,1,.79-.107,2.918,2.918,0,0,1,.431.033,3.135,3.135,0,0,1,.4.088,2.328,2.328,0,0,1,.333.126.8.8,0,0,1,.193.117.388.388,0,0,1,.064.079.3.3,0,0,1,.029.086.876.876,0,0,1,.017.136c0,.055,0,.121,0,.2s0,.167-.007.228a.787.787,0,0,1-.024.155.171.171,0,0,1-.048.088.116.116,0,0,1-.081.029.388.388,0,0,1-.164-.067c-.074-.043-.167-.09-.276-.143a2.642,2.642,0,0,0-.378-.14,1.651,1.651,0,0,0-.474-.064,1.123,1.123,0,0,0-.352.05.737.737,0,0,0-.25.136.53.53,0,0,0-.15.209.668.668,0,0,0-.05.257.572.572,0,0,0,.109.35,1.061,1.061,0,0,0,.3.262,3.117,3.117,0,0,0,.419.214c.157.067.314.138.478.214a4.631,4.631,0,0,1,.478.255,1.871,1.871,0,0,1,.416.343,1.619,1.619,0,0,1,.3.469A1.762,1.762,0,0,1,201.06,170.057Z'
              transform='translate(-197.1 -165.7)'
              fill={color || '#FFF'}
            />
          </g>
          <g transform='translate(4.778 0.119)'>
            <path
              d='M402.535,171.2a2.054,2.054,0,0,1-.012.231.548.548,0,0,1-.036.155.2.2,0,0,1-.06.086.122.122,0,0,1-.076.029h-1.516v4.883a.121.121,0,0,1-.031.083.225.225,0,0,1-.1.062.918.918,0,0,1-.19.038,2.557,2.557,0,0,1-.3.014,2.588,2.588,0,0,1-.3-.014.917.917,0,0,1-.19-.038.2.2,0,0,1-.1-.062.121.121,0,0,1-.031-.083V171.7h-1.516a.114.114,0,0,1-.078-.029.244.244,0,0,1-.057-.086.648.648,0,0,1-.036-.155,2.1,2.1,0,0,1-.012-.231,2.211,2.211,0,0,1,.012-.238.569.569,0,0,1,.036-.157.19.19,0,0,1,.057-.083.125.125,0,0,1,.078-.026h4.269a.123.123,0,0,1,.076.026.193.193,0,0,1,.06.083.644.644,0,0,1,.036.157A1.683,1.683,0,0,1,402.535,171.2Z'
              transform='translate(-397.9 -170.7)'
              fill={color || '#FFF'}
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default SubtitlesOnIcon
